import $ from 'jquery'
import OverlayController from './controllers/overlay-controller'

export default function initPageOverlay (overlayElement) {
  const overlayController = new OverlayController(overlayElement, {
    bodyVisibleClass: 'page--overlay-visible',
    bodyInvisibleClass: 'page--overlay-invisible',
    overlayVisibleClass: 'page-overlay--visible',
    overlayInvisibleClass: 'page-overlay--invisible',
    animatingClass: '.page-overlay--animating'
  })

  const $closeAreaElement = $(overlayElement).find(
    '.page-overlay__close-click-area'
  )
  $closeAreaElement.click(() => {
    overlayController.hide()
  })

  const $closeButtonElement = $(overlayElement).find(
    '.page-overlay__close-button'
  )
  $closeButtonElement.click(() => {
    overlayController.hide()
  })

  return overlayController
}
